import { getToggleTarget, setDisplayStyle, setHeightStyle } from './toggle-content'

export const fantissimaLegendVisibility = function () {
  const desktopViewport = window.matchMedia('(min-width: 1248px)')
  const legendToggle = document.querySelector('[data-js-toggle-content]')

  if (legendToggle) {
    const legendContent = getToggleTarget(legendToggle)

    let active = false

    if (desktopViewport.matches) {
      setDisplayStyle(legendContent, 'flex')
      setHeightStyle(legendContent, 'auto')
      legendToggle.setAttribute('hidden', 'hidden')
    }

    desktopViewport.onchange = (event) => {
      if (event.matches) {
        active = legendContent.style.height !== '' && legendContent.style.height !== '0px'
        setDisplayStyle(legendContent, 'flex')
        setHeightStyle(legendContent, 'auto')

        legendToggle.setAttribute('hidden', 'hidden')

        return active
      } else {
        setDisplayStyle(legendContent, active ? 'flex' : 'none')
        setHeightStyle(legendContent, active ? 'auto' : '0px')

        legendToggle.removeAttribute('hidden')
      }
    }
  }
}
